<template>
  <div class="imgForm">
    <el-button
      v-if="showCopyTextButton"
      type="text"
      size="small"
      style="margin-left: 10px"
      :loading="copyTextLoading"
      @click="handleFillCopyText"
    >
      广告文案填充
    </el-button>
    <el-tooltip
      v-if="showCopyTextButton"
      content="数据来源于智能推品"
      placement="top"
    >
      <i class="el-icon-question" style="margin-left: 4px; font-size: 14px; color: #999; cursor: pointer;"></i>
    </el-tooltip>

    <message-editor
      :value="titleList"
      @change="onTitleChange"
      label="标题"
      add-button-text="添加标题"
      input-type="text"
      placeholder="请输入标题"
      :max="5"
    />
    <message-editor
      :value="contentList"
      @change="onContentChange"
      label="描述"
      add-button-text="添加描述"
      input-type="text"
      placeholder="描述：添加其他详情"
      :max="5"
    />
    <el-form-item v-if="type == 'muti'">
      <el-input
        placeholder="请输入链接"
        v-model="currentCreative.link_url"
      ></el-input>
    </el-form-item>
    <el-form-item
      label=""
      v-else
    >
      <message-editor
        :value="messageList"
        @change="onMessageChange"
        placeholder="正文：介绍广告内容"
      >
        <template #extra>
          <el-tooltip
            effect="dark"
            placement="top"
          >
            <div slot="content">
              目前仅支持中文、英语、葡萄牙语、西班牙语 <br />
              官方说明文档：<a
                href="https://www.facebook.com/business/help/497610041230617?locale=zh_CN"
                target="_blank"
                style="color: #409eff"
                >https://www.facebook.com/business/help/497610041230617?locale=zh_CN</a
              >
            </div>
            <el-button
              type="text"
              size="small"
              @click="handleGenerateAiText"
              style="margin-left: 10px"
              :disabled="isGenerating"
            >
              智能文案推荐2
            </el-button>
          </el-tooltip>
          <el-button
            v-if="aiGenerateStatus === 'generating'"
            type="text"
            size="small"
            style="margin-left: 10px"
            disabled
          >
            <i class="el-icon-loading"></i> AI文案生成中...
          </el-button>
          <el-button
            v-if="aiGenerateStatus === 'done'"
            type="text"
            size="small"
            style="margin-left: 10px"
            @click="openAiDialog"
          >
            查看文案
          </el-button>
        </template>
      </message-editor>
    </el-form-item>

    <!-- AI文案推荐抽屉 -->
    <ai-text-drawer
      v-model="aiDialogVisible"
      :content-list="aiContentList"
      :loading="aiLoading"
      @confirm="handleAiConfirm"
    />
  </div>
</template>
<script>
import emojiInput from '@/views/adManagement/createAd/components/emojiInput';
import MessageEditor from './messageEditor.vue';
import AiTextDrawer from './aiTextDrawer.vue';
import { textGeneration, textGenerationQuery, listUserCopyText } from '@/api/creatAd';

export default {
  props: {
    creative: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'img',
    },
    accountId: {
      type: [String, Number],
      default: '',
    },
    pageId: {
      type: [String, Number],
      default: '',
    },
    instagramActorId: {
      type: [String, Number],
      default: '',
    },
    // 媒体类型（从父组件传入，用于AI文案生成）
    mediaType: {
      type: String,
      default: 'image',
    },
    // 推广网址（从父组件传入，用于AI文案生成）
    webUrl: {
      type: String,
      default: '',
    },
    // 行动号召（从父组件传入，用于AI文案生成）
    actionType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      aiDialogVisible: false,
      aiLoading: false,
      aiContentList: [],
      aiGenerateStatus: 'idle',
      currentCreativeId: null,
      queryTimer: null,
      copyTextLoading: false,
    };
  },
  components: {
    emojiInput,
    MessageEditor,
    AiTextDrawer,
  },
  computed: {
    currentCreative: {
      get() {
        let creative = this.creative || {};
        // 确保 copywriter 对象存在
        if (!creative.copywriter || typeof creative.copywriter !== 'object') {
          this.$set(creative, 'copywriter', { title: '', content: '' });
        } else {
          // 确保 copywriter 的属性存在
          if (creative.copywriter.title === undefined) {
            this.$set(creative.copywriter, 'title', '');
          }
          if (creative.copywriter.content === undefined) {
            this.$set(creative.copywriter, 'content', '');
          }
        }
        return creative;
      },
      set() {
        // this.setCreativeMsg()
      },
    },
    // 安全访问 copywriter 数据
    copywriterData() {
      return this.currentCreative?.copywriter || { title: '', content: '' };
    },
    // 将message转换为数组格式
    messageList() {
      const msg = this.currentCreative.message;
      if (Array.isArray(msg)) {
        return msg.length ? msg : [''];
      }
      // 兼容旧数据：字符串转数组
      return msg ? [msg] : [''];
    },
    // 将title转换为数组格式
    titleList() {
      const t = this.currentCreative.title;
      if (Array.isArray(t) && t.length) return t;
      // 兼容旧数据：从 copywriter.title 取
      const single = this.currentCreative?.copywriter?.title;
      return single ? [single] : [''];
    },
    // 将content转换为数组格式
    contentList() {
      const c = this.currentCreative.content;
      if (Array.isArray(c) && c.length) return c;
      // 兼容旧数据：从 copywriter.content 取
      const single = this.currentCreative?.copywriter?.content;
      return single ? [single] : [''];
    },
    isGenerating() {
      return this.aiGenerateStatus === 'generating';
    },
    // 是否显示广告文案填充按钮（单图和视频类型时才显示）
    showCopyTextButton() {
      if (this.type === 'muti') return false;
      const mediaType = this.mediaType || this.currentCreative?.media_type || '';
      return mediaType === 'image' || mediaType === 'video';
    },
  },
  beforeDestroy() {
    if (this.queryTimer) {
      clearTimeout(this.queryTimer);
      this.queryTimer = null;
    }
  },
  methods: {
    setCreativeMsg() {
      this.$emit('setCreativeMsg', this.currentCreative);
    },
    onTitleChange(val) {
      this.$set(this.currentCreative, 'title', val);
      this.$emit('setCreativeMsg', this.currentCreative);
    },
    onContentChange(val) {
      this.$set(this.currentCreative, 'content', val);
      this.$emit('setCreativeMsg', this.currentCreative);
    },
    onMessageChange(val) {
      // 使用 $set 确保响应式更新
      this.$set(this.currentCreative, 'message', val);
      this.$emit('setCreativeMsg', this.currentCreative);
    },
    async handleGenerateAiText() {
      // 获取媒体类型：优先从props传入的mediaType获取，其次从creative.media_type获取
      const mediaType = this.mediaType || this.currentCreative.media_type || 'image';

      // 获取素材URL：
      // - 对于视频广告，优先使用thumbUrl（视频封面），其次使用image
      // - 对于图片广告，优先使用url，其次使用image
      let materialUrl = '';
      if (mediaType === 'video') {
        // 视频广告：优先使用视频封面thumbUrl
        materialUrl = this.currentCreative.url || this.currentCreative.image || '';
      } else {
        // 图片广告：优先使用url，其次使用image
        materialUrl = this.currentCreative.url || this.currentCreative.image || '';
      }
      const sourceId = this.currentCreative.source_id || this.currentCreative.id || '';

      // 获取推广网址：优先从props传入的webUrl获取，其次从creative.web_url获取
      const linkUrl = this.webUrl || this.currentCreative.web_url || '';

      // 获取行动号召：优先从props传入的actionType获取，其次从creative.action_type获取
      const actionTypeValue = this.actionType || this.currentCreative.action_type || '';

      // 根据媒体类型，将素材放到对应的字段中
      // 注意：对于视频广告，这里传递的是视频封面URL，用于AI分析
      const materialItem = materialUrl
        ? { url: materialUrl, source_id: sourceId, thumbUrl: this.currentCreative.thumbUrl }
        : null;
      const imgList = mediaType === 'image' && materialItem ? [materialItem] : [];
      const videos = mediaType === 'video' && materialItem ? [materialItem] : [];

      const params = {
        titles: this.titleList.filter((v) => v && v.trim()),
        mDescriptions: this.contentList.filter((v) => v && v.trim()),
        mBodies: this.messageList.filter((v) => v && v.trim()),
        videos: videos,
        imgList: imgList,
        linkUrls: linkUrl ? [linkUrl] : [],
        accountId: String(this.accountId || ''),
        media_type: mediaType,
        page_id: String(this.pageId || ''),
        instagram_actor_id: String(this.instagramActorId || ''),
        actionTypes: actionTypeValue ? [actionTypeValue] : [],
      };

      try {
        this.aiGenerateStatus = 'generating';
        const res = await textGeneration(params);
        if (res.code === 0 && res.data) {
          this.currentCreativeId = res.data;

          this.pollQueryResult();
        } else {
          this.aiGenerateStatus = 'idle';
          //   this.$message.error(res.comment || '生成失败，请重试');
        }
      } catch (error) {
        this.aiGenerateStatus = 'idle';
        console.error('textGeneration error:', error);
        // this.$message.error('生成失败，请重试');
      }
    },
    async pollQueryResult() {
      if (!this.currentCreativeId) return;

      try {
        const res = await textGenerationQuery({ creativeId: this.currentCreativeId });
        if (res.code === 0 && res.data && res.data.length > 0) {
          this.aiContentList = res.data;
          this.aiGenerateStatus = 'done';
          this.$message.success('AI文案生成完成');
        } else if (res.code === 0) {
          this.queryTimer = setTimeout(() => {
            this.pollQueryResult();
          }, 3000);
        } else {
          this.aiGenerateStatus = 'idle';
          this.$message.error(res.comment || '生成失败，请重试');
        }
      } catch (error) {
        console.error('textGenerationQuery error:', error);
        this.aiGenerateStatus = 'idle';
        // this.queryTimer = setTimeout(() => {
        //   this.pollQueryResult();
        // }, 2000);
      }
    },
    openAiDialog() {
      this.aiDialogVisible = true;
    },
    handleAiConfirm(selectedContents) {
      const currentMessages = this.messageList.filter((v) => v && v.trim());
      const totalCount = currentMessages.length + selectedContents.length;
      if (totalCount > 5) {
        this.$message.warning('文案数量不能超过5个，请减少选择的文案数量');
        return;
      }
      let newMessages = [...currentMessages];
      for (const content of selectedContents) {
        if (!newMessages.includes(content)) {
          newMessages.push(content);
        }
      }
      this.currentCreative.message = newMessages.length ? newMessages : [''];
      this.$emit('setCreativeMsg', this.currentCreative);
      // 保持 aiGenerateStatus 为 'done'，这样用户可以继续查看和选择文案
      // this.aiGenerateStatus = 'idle';
      this.$message.success('已添加选中的文案');
    },
    // 广告文案填充
    async handleFillCopyText() {
      const saleId =
        this.currentCreative?.saleId || this.$store?.state?.num?.currentAddSaleId || '';
      if (!saleId) {
        this.$message.warning('请先选择商品');
        return;
      }

      this.copyTextLoading = true;
      try {
        const res = await listUserCopyText({ saleId });
        console.log('wcpp--res', res)
        if (res.code === 0 && res.data && res.data.length > 0) {
          // 筛选出 facebook 平台的数据
          const facebookGroup = res.data.find((item) => item.platform === 'facebook');
          if (!facebookGroup) {
            this.$message.info('没有可填充的文案');
            return;
          }
          const copyTextList = facebookGroup.copyTextList || [];

          if (copyTextList.length === 0) {
            this.$message.info('没有可填充的文案');
            return;
          }

          // 标题回填第一个
          const firstItem = copyTextList[0];
          let hasFill = false;
          if (firstItem.titleTrans) {
            this.$set(this.currentCreative, 'title', [firstItem.titleTrans]);
            hasFill = true;
          }
          // 描述（longTitleTrans）回填第一个
          if (firstItem.longTitleTrans) {
            this.$set(this.currentCreative, 'content', [firstItem.longTitleTrans]);
            hasFill = true;
          }
          // 正文（descriptionTrans）回填多个，每个 descriptionTrans 对应一个输入框
          const descriptions = copyTextList
            .map((item) => item.descriptionTrans)
            .filter((v) => v && v.trim());
          if (descriptions.length > 0) {
            this.$set(this.currentCreative, 'message', descriptions);
            hasFill = true;
          }

          if (hasFill) {
            this.$emit('setCreativeMsg', this.currentCreative);
            this.$message.success('广告文案填充完成');
          } else {
            this.$message.info('没有可填充的文案');
          }
        } else {
          this.$message.warning('没有可填充的文案');
        }
      } catch (error) {
        console.error('handleFillCopyText error:', error);
        this.$message.error('获取文案失败，请重试');
      } finally {
        this.copyTextLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imgForm {
  clear: both;
  position: relative;
  z-index: 1;
  background: #fff;

  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
